import React from "react";
import DynamicTable from "../../../../../../components/reusable/DynamicTable";
import StatusBadge from "../../../../../../utils/StatusBadge";

const TeamsTable = ({
    teams = [],
    loading = false,
    onEdit,
    onDeactivate,
    onActivate,
}) => {
    const columns = [
        {
            key: "name",
            label: "Team",
            sortable: true,
            render: (value, row) => (
                <div>
                    <div
                        style={{
                            fontWeight: 600,
                            color: "#0f172a",
                        }}
                    >
                        {value || "Unnamed Team"}
                    </div>

                    <div
                        style={{
                            marginTop: "3px",
                            fontSize: "12px",
                            color: "#64748b",
                        }}
                    >
                        Code:{" "}
                        {row.code || "—"}
                    </div>
                </div>
            ),
        },
        {
            key: "office_name",
            label: "Office",
            sortable: true,
            render: (value) => value || "—",
        },
        {
            key: "department_name",
            label: "Department",
            sortable: true,
            render: (value) => value || "—",
        },
        {
            key: "team_lead_name",
            label: "Team Lead",
            sortable: true,
            render: (value) => value || "—",
        },
        {
            key: "is_active",
            label: "Status",
            sortable: true,
            render: (value) => (
                <StatusBadge status={ value ? "active" : "inactive" } />
            ),
        },
        {
            key: "description",
            label: "Description",
            render: (value) => (
                <span
                    style={{
                        display: "block",
                        maxWidth: "260px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        color: "#64748b",
                    }}
                    title={ value || "" }
                >
                    {value || "—"}
                </span>
            ),
        },
    ];

    const actions = [
        {
            buttonType: "editIcon",
            onClick: (team) => { onEdit?.(team); },
        },
        {
            buttonType: "moreOptions",
            onClick: () => {},
            getDropdownOptions: (team) => [
                {
                    label: "Activate",
                    onClick: () => { if (!team.is_active) { onActivate?.(team); } }
                },
                {
                    label: "De-Activate",
                    onClick: () => { if (team.is_active) { onDeactivate?.(team); } }
                },
            ],
        },
    ];

    if (loading) {
        return (
            <div
                style={{
                    padding: "30px",
                    textAlign: "center",
                    background: "#ffffff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "12px",
                    color: "#64748b",
                }}
            >
                Loading teams...
            </div>
        );
    }

    if (!teams.length) {
        return (
            <div
                style={{
                    padding: "40px",
                    textAlign: "center",
                    background: "#ffffff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "12px",
                    color: "#64748b",
                }}
            >
                No teams found.
            </div>
        );
    }

    return (
        <DynamicTable
            columns  = { columns }
            data     = { teams }
            onAction = { actions }
        />
    );
};

export default TeamsTable;
